import storage from '@dashboard/services/storage';
import { clearAuthCookie } from '@dashboard/services/authCookie';
import { THEME_STORAGE_KEY } from '@dashboard/lib/theme';

// Wipes all of localStorage, not just the auth keys: command palette recents and page caches
// hold customer and page names. The theme is a device setting, so it survives.
export function clearSession() {
  const theme = storage.local.getItem(THEME_STORAGE_KEY);
  storage.local.clear();
  if (theme) storage.local.setItem(THEME_STORAGE_KEY, theme);
  document.cookie = clearAuthCookie();
}
